function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.75h30v22.5H0V3.75Z",
    style: {
      fill: "#007fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35,8.25h3.15l.975-3.15.975,3.15h3.15l-2.55,1.95.975,3.15-2.55-1.95-2.55,1.95.975-3.15-2.55-1.95ZM28.125,3.75L0,20.625v5.625h1.875L30,9.375V3.75h-1.875",
    style: {
      fill: "#f7d618"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,3.75L0,21.75v4.5L30,8.25V3.75",
    style: {
      fill: "#ce1021"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/CD.6efd1dc0c3c1ed6228e2f8aeede2be5a.svg";
export { ForwardRef as ReactComponent };